module.exports = __webpack_public_path__ + "img/fashion_33.1723707f.jpg";